import { Controller } from "@hotwired/stimulus";
class default_1 extends Controller {
    connect() {
        this.initMatomo();
    }
    initMatomo() {
        if (!this.urlValue || !this.siteIdValue)
            return;
        window._paq = window._paq || [];
        window._paq.push(["trackPageView"]);
        window._paq.push(["enableLinkTracking"]);
        window._paq.push(["setTrackerUrl", `${this.urlValue}matomo.php`]);
        window._paq.push(["setSiteId", this.siteIdValue]);
        // Prevent duplicate script injection
        if (document.querySelector('script[data-matomo="true"]'))
            return;
        const script = document.createElement("script");
        script.async = true;
        script.src = `${this.urlValue}matomo.js`;
        script.dataset.matomo = "true";
        document.head.appendChild(script);
    }
}
default_1.values = {
    url: String,
    siteId: String,
};
export default default_1;
